import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1437502b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1437502b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1437502b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1437502b')) {
      api.createRecord('1437502b', component.options)
    } else {
      api.reload('1437502b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1437502b&scoped=true", function () {
      api.rerender('1437502b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/IntelligentInvestmentAssistant/index.vue"
export default component.exports